import { render, staticRenderFns } from "./TraxAccountGroupCrudTable.vue?vue&type=template&id=ba9ee1c4"
import script from "./TraxAccountGroupCrudTable.vue?vue&type=script&lang=js"
export * from "./TraxAccountGroupCrudTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports